// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3sOWx","fileBtn":"File_fileBtn__rcMcQ","closeBtn":"File_closeBtn__1jRbR","fileSelected":"File_fileSelected__2FzTx","disabled":"File_disabled__2ToqB"};